import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoggerSystemService {
    // Temporalmente sin environment.loggerSystemUrl
    private _loggerSystemUrl = new BehaviorSubject<string>('');

    get loggerSystemUrl$(): Observable<string> {
        return this._loggerSystemUrl.asObservable();
    }

    set loggerSystemUrl$(url: string) {
        this._loggerSystemUrl.next(url);
    }

    setLoggerSystemUrl(baseUrl: string, route?: string): void {
        this._loggerSystemUrl.next(baseUrl);
        const path =
            route?.replace(/^\/(?:external\/)?logger-system\/?/, '') || null;
        this._loggerSystemPath.next(
            path ? (path.startsWith('/') ? path : `/${path}`) : null
        );
    }

    private _loggerSystemPath = new BehaviorSubject<string | null>(null);

    get loggerSystemPath$(): Observable<string | null> {
        return this._loggerSystemPath.asObservable();
    }

    constructor() {}
}
